export type CloudinaryVideoProps = {
  className?: string
  cloudName: string
  publicId: string
  autoplay: boolean
  controls: boolean
  loop: boolean
  muted: boolean
  playsinline?: boolean
  preload?: PreloadOptions
}

export enum PreloadOptions {
  none = 'none',
  auto = 'auto',
  metadata = 'metadata'
}
